import withStyles from '@mui/styles/withStyles';
import Typography from '@classify/react-core-components/Typography';

import { palette } from '../../../theme';

export const styles = ({ spacing }) => ({
  root: {},
  textContainer: {
    display: 'inline',
    padding: `${spacing(0.25)} 0 ${spacing(0.5)} 0`,
    boxDecorationBreak: 'clone',
  },
});

export const MarketingHeadline = ({
  backgroundColor = palette.brand.onContrasted,
  children = null,
  classes = {},
  color = palette.text.onContrasted,
  variant = 'h1',
  ...otherProps
}) => {
  const style = {
    backgroundColor,
    color,
    boxShadow: `16px 0 0 ${backgroundColor}, -16px 0 0 ${backgroundColor}`,
  };

  return (
    <Typography
      className={classes.root}
      variant={variant}
      {...otherProps}
      sx={{
        marginLeft: 2,
      }}
    >
      <span className={classes.textContainer} style={style}>
        {children}
      </span>
    </Typography>
  );
};

export default withStyles(styles)(MarketingHeadline);
